/*
 * Copyright (c) 2020, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import { AuthProvider, Storage } from "@asgardeo/auth-react";

import Settings from './conf/settings';
import './index.css';
import App from './App';
import { init as hjInit } from './util/hotjar';
import { Provider } from 'react-redux';
import store from './store';

import { BrowserRouter as Router } from "react-router-dom";

const config = {
  resourceServerURLs: [Settings.idpHost, Settings.apimHost, Settings.apimApi, Settings.apiServiceHost, Settings.clientHost, Settings.tokenExchangeUrl, Settings.graphqlServiceHost],
  endpoints: {...Settings.overrideEndpoints},
  overrideWellEndpointConfig: Settings.overrideWellEndpointConfig,
  signInRedirectURL: Settings.signInRedirectUrl,
  signOutRedirectURL: Settings.signOutRedirectUrl,
  clientHost: Settings.clientHost,
  clientID: Settings.clientId,
  enablePKCE: Settings.enablePKCE,
  serverOrigin: Settings.idpHost,
  storage: Storage.WebWorker,
  scope: Settings.scopes,
  checkSessionInterval: -1,
  disableTrySignInSilently: true,
  wellKnownEndpoint: Settings.wellKnownEndpoint,
  validateIDToken: Settings.validateIDToken,
};

/* Temporary removed the hotjar tracking function due to a GDPR security concerns */
// hjInit();

ReactDOM.render(
  <AuthProvider config={config}>
    <Provider store={store}>
      <Router>
        <App />
      </Router>
    </Provider>
  </AuthProvider>
  ,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
